import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import { Check } from 'lucide-react';
import * as React from 'react';

import { cn } from '@/lib/utils';

const Checkbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>
>(({ className, ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    className={cn(
      'peer h-4 w-4 shrink-0 rounded-sm',
      // Border
      'border border-border/60',
      // Background
      'bg-abyss-dark/60',
      // Shadow
      'shadow-[inset_0_1px_2px_rgba(0,0,0,0.3)]',
      // Focus
      'focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-biolume-cyan/50',
      'focus-visible:border-biolume-cyan/50',
      // Disabled
      'disabled:cursor-not-allowed disabled:opacity-50',
      // Checked state
      'data-[state=checked]:bg-biolume-cyan/20 data-[state=checked]:border-biolume-cyan/50',
      'data-[state=checked]:shadow-[0_0_8px_rgba(34,211,238,0.3)]',
      // Transition
      'transition-all duration-200',
      className
    )}
    {...props}
  >
    <CheckboxPrimitive.Indicator
      className={cn('flex items-center justify-center text-biolume-cyan')}
    >
      <Check className="h-3 w-3" strokeWidth={3} />
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
));
Checkbox.displayName = CheckboxPrimitive.Root.displayName;

export { Checkbox };
